/* Carrito /cart HerBalance — generado por paginas-v2/construir_shopify.py.
   Misma lógica que «Tu pedido» (ova-marco.js): el pack es la cantidad de OvaBloom (descuentos automáticos) y la suscripción
   lleva a la página de suscripción con el plan. Precios de la suscripción: #ova2-carrito-config (sección ova-carrito del pie). */
(() => {
  const caja = document.getElementById('k-carrito');
  if (!caja) return;
  const base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const CAB = { 'Content-Type': 'application/json', Accept: 'application/json' };
  const PLAN = { 1: '1-frasco', 2: '2-frascos', 3: '3-frascos' };
  const CADA = { 1: 'cada mes', 2: 'cada 2 meses', 3: 'cada 3 meses' };
  const pesos = n => '$' + Math.round(n).toLocaleString('es-CO');
  const error = document.getElementById('k-error');
  let cfg = null;
  try { cfg = JSON.parse(document.getElementById('ova2-carrito-config').textContent); } catch (e) {}

  const espera = ms => new Promise(ok => setTimeout(ok, ms));
  async function cambiar(clave, cantidad) {
    caja.classList.add('ocupado');
    error.hidden = true;
    const pedir = () => fetch(base + 'cart/change.js', { method: 'POST', headers: CAB, body: JSON.stringify({ id: clave, quantity: cantidad }) });
    try {
      let r = await pedir();
      // Shopify a veces responde 503 o 429 por un momento (visto el 1-oct): se reintenta una vez, como «Tu pedido».
      if (r.status === 429 || r.status >= 500) { await espera(900); r = await pedir(); }
      if (!r.ok) throw new Error('cart/change ' + r.status);
      location.reload();
    } catch (e) {
      caja.classList.remove('ocupado');
      error.textContent = 'No pudimos actualizar tu pedido. Intenta de nuevo.';
      error.hidden = false;
    }
  }

  // Pack: cambia la cantidad de la línea de OvaBloom.
  caja.querySelectorAll('.k-pack').forEach(b => b.addEventListener('click', () => {
    if (b.getAttribute('aria-checked') === 'true' && modo === 'unica') return;
    if (modo === 'sus') { n = Number(b.dataset.n); pintarModo(); if (Number(caja.dataset.n) === n) return; }
    cambiar(caja.dataset.clave, Number(b.dataset.n));
  }));
  // Quitar: sin recargar la página entera a /cart/change (el enlace funciona igual sin JavaScript).
  caja.querySelectorAll('[data-quitar]').forEach(a => a.addEventListener('click', e => { e.preventDefault(); cambiar(a.dataset.quitar, 0); }));

  // Suscripción: solo con 1, 2 o 3 frascos y si «Tu pedido» la tiene activa.
  let n = Number(caja.dataset.n), modo = 'unica';
  const bloque = document.getElementById('k-modos-bloque');
  if (!cfg || !cfg.susActiva || !bloque || n < 1 || n > 3) return;
  bloque.hidden = false;
  const filas = document.getElementById('k-filas');
  const filasUnica = filas.innerHTML;
  const form = document.getElementById('k-form');
  const ctaSus = document.getElementById('k-cta-sus');
  const nota = document.getElementById('k-nota');
  const hechos = document.getElementById('k-hechos');
  const hechosUnica = hechos.innerHTML;
  const pct = (precio, k) => Math.floor((1 - precio / (cfg.unica[1] * k)) * 100);
  const urlSus = k => {
    const u = new URL(String(cfg.susUrl || '').replace(/\/+$/, '') + '/' + PLAN[k], location.href);
    try { Object.entries(JSON.parse(sessionStorage.getItem('ova2-utm') || '{}')).forEach(([a, v]) => u.searchParams.set(a, v)); } catch (e) {}
    return u.toString();
  };

  function pintarModo() {
    caja.querySelectorAll('.k-modo').forEach(b => b.setAttribute('aria-checked', String(b.dataset.modo === modo)));
    document.querySelector('[data-sus-titulo]').textContent = 'Suscripción · ahorra ' + pct(cfg.sus[n], n) + ' %';
    document.querySelector('[data-sus-detalle]').textContent = 'Te llega sola ' + CADA[n] + '. Pausas o cancelas cuando quieras';
    caja.querySelectorAll('.k-pack').forEach(b => {
      const k = Number(b.dataset.n), precio = modo === 'sus' ? cfg.sus[k] : cfg.unica[k], a = pct(precio, k);
      b.setAttribute('aria-checked', String(k === n));
      b.querySelector('[data-precio]').textContent = pesos(precio);
      b.querySelector('[data-ahorro]').textContent = a > 0 ? 'Ahorra ' + a + ' %' : 'Precio normal';
    });
    if (modo === 'sus') {
      const normal = cfg.unica[1] * n;
      filas.innerHTML = `<div class="fila"><span>${n} ${n === 1 ? 'frasco' : 'frascos'} a precio normal</span><span class="tachado">${pesos(normal)}</span></div>
        <div class="fila ahorro"><span>Ahorras con la suscripción</span><b>−${pesos(normal - cfg.sus[n])}</b></div>
        <div class="fila"><span>Envío</span><b>Gratis</b></div>
        <div class="fila total"><span>Se cobran</span><b>${pesos(cfg.sus[n])} <small>${CADA[n]}</small></b></div>`;
      form.hidden = true;
      ctaSus.hidden = false;
      ctaSus.href = urlSus(n);
      ctaSus.textContent = 'Suscribirme · ' + pesos(cfg.sus[n]);
      nota.textContent = 'La suscripción se paga en línea. Te avisamos antes de cada envío.';
      hechos.innerHTML = '<li><svg class="ico"><use href="#i-camion"/></svg><span>Envío gratis en cada entrega</span></li><li><svg class="ico"><use href="#i-pausa"/></svg><span>Pausas o cancelas cuando quieras</span></li><li><svg class="ico relleno"><use href="#i-wa"/></svg><span>Soporte prioritario por WhatsApp</span></li>';
    } else {
      n = Number(caja.dataset.n);
      filas.innerHTML = filasUnica;
      form.hidden = false;
      ctaSus.hidden = true;
      nota.textContent = 'Llega en 3 a 7 días hábiles.';
      hechos.innerHTML = hechosUnica;
      caja.querySelectorAll('.k-pack').forEach(b => b.setAttribute('aria-checked', String(Number(b.dataset.n) === n)));
    }
  }
  caja.querySelectorAll('.k-modo').forEach(b => b.addEventListener('click', () => { modo = b.dataset.modo; pintarModo(); }));
  pintarModo();
})();
